import React from 'react';
import { motion } from 'framer-motion';
import { Car, Navigation, Handshake, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ServicesOverview() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const services = [{
    icon: Car,
    title: 'Comprá o vendé tu auto',
    desc: 'Amplio stock de autos usados y 0km. SUVs, sedanes, camionetas y más. Financiación disponible hasta el 100%.',
    action: () => scrollToSection('stock'),
    actionText: 'Ver más →',
    isLink: false
  }, {
    icon: Navigation,
    title: 'Trabajá en apps con nuestros autos',
    desc: 'Alquilá un vehículo para trabajar en Uber, Cabify, inDriver y más. Turno 12hs, a cargo 24hs, o con opción a compra.',
    action: () => scrollToSection('alquiler'),
    actionText: 'Ver más →',
    isLink: false
  }, {
    icon: Handshake,
    title: 'Dejanos tu auto',
    desc: 'Lo vendemos por vos o lo ponemos a trabajar en apps y te generamos una rentabilidad mensual en pesos.',
    action: () => scrollToSection('consignacion'),
    actionText: 'Ver más →',
    isLink: false
  }, {
    icon: TrendingUp,
    title: 'Invertí en dólares',
    desc: 'Nuestro modelo ya funciona y ya estamos pagando. Generá un 2% mensual en dólares de forma pasiva. Nosotros operamos, vos cobrás.',
    action: 'https://project-flash-and-go-investor-landing-page-109.magicpatterns.app',
    actionText: 'QUIERO INVERTIR →',
    isLink: true
  }];
  return <section className="py-32 bg-brand-black relative" data-id="element-451" data-mp="3qhb951dlt1vx">
      <div className="max-w-7xl mx-auto px-6" data-id="element-452" data-mp="1ud3qtdt68j5z">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-453" data-mp="1zavhy5lzs194">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white" data-id="element-454" data-mp="289gzpyjn3c8u">
            Todo lo que necesitás,{' '}
            <span className="text-brand-gold" data-id="element-455" data-mp="2i9r895uqbvho">en un solo lugar</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-456" data-mp="2n0pvkpe4xtuf">
          {services.map((service, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#111] border-t-4 border-t-brand-gold p-8 rounded-b-lg shadow-lg hover:bg-[#151515] transition-colors group" data-id="element-457" data-mp="2rzaw6pxaufje" data-mpi={i}>
              <service.icon className="w-12 h-12 text-brand-gold mb-6" data-id="element-458" data-mp="gd8rprh5gndj" />
              <h3 className="font-heading text-3xl text-brand-white mb-4" data-id="element-459" data-mp="bdnoh4uy5sv0">
                {service.title}
              </h3>
              <p className="text-brand-white/70 mb-8 leading-relaxed min-h-[80px]" data-id="element-460" data-mp="182bvz791dxq6">
                {service.desc}
              </p>

              {service.isLink ? <a href={service.action as string} className="inline-flex items-center justify-center px-6 py-3 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-461" data-mp="zajn30znuwnp">
                  {service.actionText}
                </a> : <button onClick={service.action as () => void} className="text-brand-gold font-bold hover:text-brand-white transition-colors flex items-center gap-2 group-hover:gap-3" data-id="element-462" data-mp="1mzvupwfcawnw">
                  {service.actionText}
                </button>}
            </motion.div>)}
        </div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-463" data-mp="12kciyy5evpuk"></div>
    </section>;
}